
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply-for-vendor",
      function () {
        return require("private-next-pages/apply-for-vendor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply-for-vendor"])
      });
    }
  